module.exports = __webpack_public_path__ + "img/sample_profile-photo-1_500x500.91c51495.jpg";